exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-button{\n  right: 16px;\n  top: 0px;\n  padding: 7px;\n  z-index:1;\n  color: rgb(7, 7, 7);\n  background-color: #e3ecf0;\n  border-color: #2C2754; /*set the color you want here*/\n}\n\n.add-button:hover, .add-button:focus, .add-button:active, .add-button.active, .open>.dropdown-toggle.add-button {\n  color: #fff;\n  background-color: #2C2754 ;\n  border-color: #2C2754 ; /*set the color you want here*/\n}\n.orientation{\n  margin-bottom: 5px;\n  clear: both;\n  float: right;\n}\n.tdprop{\n  padding-top: 20px;\n}\n.srctxt{\n  margin-top: 20px;\n}\n\n.table-striped.table-bordered{\n  text-align: center;\n}\n.table > thead > tr > th {\n  text-align: center;\n}\n.showActive{\n  display: none;\n}\n\n#left{\n  margin-top: 20px;\n  margin-left: 3px;\n}\n\n#padding{\n  padding: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/manage-user/manage-user/manage-user.component.css
// module id = ../../../../../src/app/parent/dashboard/pages/manage-user/manage-user/manage-user.component.css
// module chunks = main